/* eslint-disable react/forbid-dom-props */
import React from 'react'

export const LogOutIcon = () => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" width="32" height="32">
    <defs>
      <path
        id="log_out_a"
        d="M17.473 7.798l-5.907 5.906c-.527.527-1.441.158-1.441-.598V9.731H5.344a.842.842 0 01-.844-.844V5.512c0-.467.376-.843.844-.843h4.781V1.294c0-.753.91-1.125 1.441-.598l5.907 5.906a.852.852 0 010 1.196zM6.75 13.528v-1.406a.423.423 0 00-.422-.422H3.375a1.124 1.124 0 01-1.125-1.125v-6.75c0-.622.503-1.125 1.125-1.125h2.953c.232 0 .422-.19.422-.422V.872A.423.423 0 006.328.45H3.375A3.376 3.376 0 000 3.825v6.75a3.376 3.376 0 003.375 3.375h2.953c.232 0 .422-.19.422-.422z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h32v32H0z" />
      <g transform="translate(7 9)">
        <mask id="log_out_b" fill="#fff">
          <use xlinkHref="#log_out_a" />
        </mask>
        <g fill="#9A8B88" fillRule="nonzero" mask="url(#log_out_b)">
          <path d="M-1.8-3.6h21.6V18H-1.8z" />
        </g>
      </g>
    </g>
  </svg>
)
